import { IGenericModelFields } from "./IGenericFields";

export enum CollaborationInviteStatus {
    PENDING = "pending",
    ACCEPTED = "accepted"
}

export interface ICollaborationInvite extends IGenericModelFields {
    invitedBy: string;
    inviteeEmail: string;
    inviteeUid: string;
    permissions: {
        write: boolean;
        read: boolean;
    };
    presentationId: string;
    status: CollaborationInviteStatus;
}
